import { useEffect, useState } from 'react';
import { useAdminAuthStore } from './store/adminAuthStore';
import { adminMe } from './api/auth';
import { getSetupStatus, type SetupStatus } from './api/setup';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { ConsolePage } from './pages/ConsolePage/ConsolePage';
import { SetupWizard } from './pages/SetupWizard/SetupWizard';

/**
 * admin-frontend 진입 — 설치 게이트 → 세션 기반 분기(로그인 ↔ 콘솔).
 *  1) /setup/status 로 최초 설치 필요 여부 확인(회사정보 비어있으면 부트스트랩 마법사).
 *  2) 설치 완료 상태면 /auth/me 로 기존 admin_at 세션 확인(새로고침 후 유지).
 * install-bootstrap Part B: 설치 마법사 분기는 additive — 기존 설치본은 needsSetup=false 라 마법사 미노출.
 */
export function App() {
  const status = useAdminAuthStore((s) => s.status);
  const setAuthenticated = useAdminAuthStore((s) => s.setAuthenticated);
  const clearSession = useAdminAuthStore((s) => s.clearSession);

  // null = 확인 중. 설치 필요 시 SetupStatus, 아니면 'ready'(세션 분기로 진행).
  const [setup, setSetup] = useState<SetupStatus | 'ready' | null>(null);

  useEffect(() => {
    let cancelled = false;
    getSetupStatus()
      .then((s) => {
        if (cancelled) return;
        if (s.needsSetup) { setSetup(s); return; }
        setSetup('ready');
        // 설치 완료 → 기존 세션 확인.
        adminMe()
          .then((u) => { if (!cancelled) setAuthenticated(u); })
          .catch(() => { if (!cancelled) clearSession(); });
      })
      .catch(() => {
        // setup/status 실패(예: 구버전 BFF) → 기존 흐름으로 폴백.
        if (cancelled) return;
        setSetup('ready');
        adminMe()
          .then((u) => { if (!cancelled) setAuthenticated(u); })
          .catch(() => { if (!cancelled) clearSession(); });
      });
    return () => { cancelled = true; };
  }, [setAuthenticated, clearSession]);

  // 설치 상태 확인 중.
  if (setup === null) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>로딩 중…</div>;
  }

  // 최초 설치 필요 → 부트스트랩 마법사. 완료 시 새로고침하여 로그인 화면으로.
  if (setup !== 'ready' && setup.needsSetup) {
    return <SetupWizard initialStep={setup.step} onDone={() => window.location.reload()} />;
  }

  if (status === 'pending') {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>로딩 중…</div>;
  }
  return status === 'authenticated' ? <ConsolePage /> : <LoginPage />;
}
